import * as React from 'react';
import {
  Image,
  ImageStyle,
  StyleSheet,
  Text,
  TextStyle,
  View,
  ViewStyle,
} from 'react-native';

import PrimaryButton from '../../../shared/buttons/PrimaryButton';
import CheckButton from '../../../shared/forms/CheckButton';
import SvgUriAdapter from '../../../shared/svg/SvgUriAdapter';

import fullVideoKindlUri from '../../../../../assets/svgs/full-video-kind.svg';

interface Props {
  onPress: () => void;
}

const ServiceExplanationStep2: React.FunctionComponent<Props> = props => {
  const {onPress} = props;
  const [checked, setChecked] = React.useState(false);
  const onPressCheck = React.useCallback(() => {
    setChecked(!checked);
  }, [checked]);
  return (
    <View style={styles.container}>
      <Text style={styles.message}>
        タテ型とヨコ型の2種類の動画を作成できます。
        タテ型はスマホで気軽に観る短尺の動画に、ヨコ型はPCやテレビでじっくり観る長尺の動画に向いています。
      </Text>
      <View style={styles.kind}>
        <SvgUriAdapter uri={fullVideoKindlUri} width={320} height={178} />
      </View>
      <CheckButton
        style={styles.checkButton}
        checked={checked}
        onPress={onPressCheck}>
        理解した
      </CheckButton>
      <PrimaryButton disabled={!checked} onPress={onPress}>
        次へ
      </PrimaryButton>
    </View>
  );
};

export default React.memo(ServiceExplanationStep2);

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#fff',
    borderTopColor: '#efefef',
    borderTopWidth: 1,
    flex: 1,
    alignItems: 'center',
    paddingVertical: 32,
  } as ViewStyle,
  message: {
    color: '#383838',
    fontSize: 14,
    marginHorizontal: 24,
  } as TextStyle,
  kind: {
    marginVertical: 24,
  } as ViewStyle,
  checkButton: {
    width: 160,
    justifyContent: 'center',
    marginBottom: 16,
  } as ViewStyle,
});
